import type { NavigationState } from '@luminovo/design-system';

declare module '@luminovo/design-system' {
    interface NavigationState {
        /**
         * The app whose widget asked for the navigation. On the history entry, not in a module, so Back, Forward and
         * a reload of an app-linked URL keep the attribution with its page.
         */
        widgetNavigation?: string;
    }
}

/** The navigation state the host attaches when a widget asked for the navigation. */
export const widgetNavigationState = (appId: string): NavigationState => ({ widgetNavigation: appId });
